import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Box,
} from "@mui/material";
import { doc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebaseConfig"; // Ajusta la importación según tu estructura de carpetas

// Modal para agregar o editar productos
function ProductFormModal({
  open,
  handleClose,
  product = null,
  fetchProducts,
}) {
  const [productName, setProductName] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [productPrice, setProductPrice] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [productImagenUrl, setProductImagenUrl] = useState("");

  // Efecto para cargar datos si estamos editando un producto
  useEffect(() => {
    if (product) {
      setProductName(product.nombre);
      setProductDescription(product.descripcion);
      setProductPrice(product.precio);
      setProductCategory(product.categoria);
    }
  }, [product]);

  // Función para agregar o editar el producto
  const handleSave = async () => {
    const newProductData = {
      nombre: productName,
      descripcion: productDescription,
      precio: productPrice,
      categoria: productCategory,
      imagenUrl: productImagenUrl,
      destacado: false,
      visible: true,
    };

    if (product) {
      // Si existe el producto (estamos editando)
      try {
        const productRef = doc(db, "bebidas", product.id); // Usar el ID del producto
        await updateDoc(productRef, newProductData);
        console.log("Producto editado");
      } catch (error) {
        console.error("Error al editar el producto:", error);
      }
    } else {
      // Si no existe el producto (estamos agregando)
      try {
        const newProductRef = doc(db, "bebidas", productName); // Puedes usar otro ID único aquí
        await setDoc(newProductRef, newProductData);
        console.log("Producto agregado");
      } catch (error) {
        console.error("Error al agregar el producto:", error);
      }
    }

    fetchProducts(); // Actualiza la lista de productos después de agregar/editar
    handleClose(); // Cierra el modal después de guardar
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        {product ? "Editar Producto" : "Agregar Producto"}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label="Nombre del Producto"
            variant="outlined"
            value={productName}
            onChange={(e) => setProductName(e.target.value)}
            fullWidth
          />
          <TextField
            label="Descripción"
            variant="outlined"
            value={productDescription}
            onChange={(e) => setProductDescription(e.target.value)}
            fullWidth
          />
          <TextField
            label="Precio"
            type="number"
            variant="outlined"
            value={productPrice}
            onChange={(e) => setProductPrice(e.target.value)}
            fullWidth
          />
          <TextField
            label="Categoría"
            variant="outlined"
            value={productCategory}
            onChange={(e) => setProductCategory(e.target.value)}
            fullWidth
          />
          <TextField
            label="Imagen"
            variant="outlined"
            value={productImagenUrl}
            onChange={(e) => setProductImagenUrl(e.target.value)}
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancelar
        </Button>
        <Button onClick={handleSave} color="primary">
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ProductFormModal;
